import { useEffect } from 'react';
import { Select } from '@nimbus-ds/components';
import { FormField } from '@nimbus-ds/patterns';
import { InterfaceNameValue } from '@tiendanube/components';
import { useToastStatus } from 'commons/hooks';
import { InterfaceNameBooleanValue } from 'commons/types';
import { PersonalDataState } from 'domains/PagoNubeOnboarding/Onboarding/types';
import useTranslationPagoNubeOnboarding from 'domains/PagoNubeOnboarding/useTranslationPagoNubeOnboarding';
import useGetStoreCategories from '../hooks/useGetStoreCategories';

interface Props {
  errors: Partial<Record<string, string>>;
  onChange: (data: InterfaceNameValue | InterfaceNameBooleanValue) => void;
  personalDataState: PersonalDataState;
}

function StoreCategory({
  errors,
  onChange,
  personalDataState,
}: Readonly<Props>) {
  const t = useTranslationPagoNubeOnboarding('storeCategory');

  const { fetchStoreCategories, storeCategoryState } = useGetStoreCategories();
  const storeCategories = storeCategoryState.data;

  useEffect(() => {
    if (!storeCategories || storeCategories.length === 0) {
      fetchStoreCategories();
    }
  }, [fetchStoreCategories, storeCategories]);

  useToastStatus({
    status: storeCategoryState.status,
    error: t('error'),
  });

  return (
    <FormField.Select
      key="storeCategory"
      id="storeCategory"
      appearance={errors['storeCategory'] ? 'danger' : 'none'}
      disabled={storeCategories?.length === 0}
      name="storeCategory"
      label={t('storeCategory')}
      onChange={(e) =>
        onChange({ name: 'storeCategory', value: e.target.value })
      }
      property="storeCategory"
      value={personalDataState['storeCategory'] || ''}
      showHelpText={!!errors['storeCategory']}
      helpText={errors['storeCategory']}
    >
      {storeCategories?.length === 0 ? (
        <Select.Option label={t('loading')} value="loading" />
      ) : (
        <Select.Option
          key="storeCategory"
          label={t('selectCategory')}
          value=""
        />
      )}
      {storeCategories?.map((category) => (
        <Select.Option
          key={category.code}
          label={category.description}
          value={category.code}
        />
      ))}
    </FormField.Select>
  );
}

export default StoreCategory;
